<!--
History eines Devices anzeigen
-->
<template>

    <span v-if="value && value.id">

      <b-button variant="outline-info" size="sm" @click="showDeviceHistory()">
              <b-icon icon="clock-history"
                      v-b-tooltip.hover
                      :title="$t('message.deviceHistory_aeltere')">
              </b-icon>
      </b-button>

      <b-modal :id="'modal-tldh-' + value.id"
               :title="$t('message.deviceHistory_vorherige') + value.name"
               :hide-footer="true"
               size="lg">

        <span v-if="traplinkedDeviceHistory && traplinkedDeviceHistory.length > 0">

          <div class="table-responsive">
            <b-table striped
                   :items="traplinkedDeviceHistory"
                   :fields="fields"
                   :current-page="currentPage"
                   :per-page="perPage"
                   small
                   hover>

              <template v-slot:cell(timestamp)="row">
                <span v-if="row.item.timestamp">
                  {{ javaDateToDefaultTimeFormat(row.item.timestamp) }}
                </span>
              </template>

              <template v-slot:cell(deviceStatus)="row">
                <device-status v-model="row.item.deviceStatus"
                               :report-type="row.item.reportType"
                               :event-type="row.item.eventType"
                               :id="row.item.id"
                />
              </template>

              <template v-slot:cell(batteryStatus)="row">
                <span v-if="row.item.batteryStatus">
                  <batterie-status v-model="row.item.batteryStatus" />
                </span>
              </template>

            </b-table>
          </div>

          <b-row>
            <b-col md="12" class="my-1">
              <b-pagination :total-rows="totalRows"
                            :per-page="perPage"
                            v-model="currentPage"
                            class="my-0" />
            </b-col>
          </b-row>

        </span>
        <b-alert v-else variant="info" show>{{ $t('message.deviceHistory_noch_keine') }}</b-alert>

      </b-modal>

    </span>

</template>
<script>

  import BatterieStatus from '@/components/traplinkedbericht/BatterieStatus';
  import axios from 'axios'
  import DeviceStatus from '@/components/traplinkedbericht/DeviceStatus.vue'

  // Define a new component
  export default {

    name: 'DeviceHistory',
    components: {
      DeviceStatus,
      BatterieStatus,
    },
    props: ['value'], // das Device
    /*
      Defines the data used by the component
    */
    data: function () {
      return {
        /** Liste mit historischen Daten */
        traplinkedDeviceHistory: null,
        fields: [
          {
            key: 'timestamp',
            label: this.$t('message.deviceHistory_zeitpunkt'),
            sortable: true,
            order: 30,
          },
          {
            key: 'deviceStatus',
            label: this.$t('message.printMaengel_status'),
            sortable: true,
            order: 40,
          },
          {
            key: 'description',
            label: this.$t('message.api_table_result_remarks'),
            sortable: true,
            order: 45,
          },
          {
            key: 'batteryStatus',
            label: this.$t('message.deviceHistory_akku'),
            sortable: true,
            order: 50,
          }
        ],
        /** ausgewählter Wert aus den pageOptions */
        perPage: 10,
        /** Pagination der Ergebnistabelle */
        currentPage: 0,
        totalRows: 0,
      }
    },
    watch: {

      value: function () {
        this.traplinkedDeviceHistory = null
      }

    },
    methods: {

      /** Modal öffnen um Device History anzuzeigen */
      showDeviceHistory: function () {

        if (this.value) {

          this.showSpinner()
          const customer = this.$store.getters.customer
          const url      = process.env.VUE_APP_SERVER_URL + '/datenbroker/getTraplinkedDeviceHistory'
          const params   = {
            customer_id:          customer.id,
            traplinked_device_id: this.value.id
          }

          this.traplinkedDeviceHistory = null
          this.totalRows = 0

          const that = this
          axios({
            method: 'GET',
            params: params,
            url: url,
          }).then(function (response) {

            console.log('response = ' + response)
            that.hideSpinner()
            if (response.data) {

              that.traplinkedDeviceHistory = response.data.traplinkedReports
              that.totalRows = that.traplinkedDeviceHistory.length
              // modal öffnen
              console.log('öffne modal modal-tldh-' + that.value.id)
              that.$bvModal.show('modal-tldh-' + that.value.id)

            }

          }).catch(error => {
            console.log(error)
          })

        }

      }

    }

  }

</script>
